import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import "./index.scss";
import "./i18n";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";



// ** Import custom components for redux **
import { Provider } from "react-redux";
import store from "./store";
import MainRoutes from "./routes";
import Loader from "./components/common/loader";
import ToastifyNotification from "./components/ToastifyNotification";
import ShortcutHandler from "./utils/ShortcutHandler";

const Root = () => {


  
  return (
    <div className="App">
      <Provider store={store}>
        <ToastifyNotification />
        <Loader />
        <BrowserRouter>
          <ShortcutHandler />
          <MainRoutes />
        </BrowserRouter>
      </Provider>
      {/* </Auth0Provider> */}
    </div>
  );
};

// ✅ React 18 way to render the app
const container = document.getElementById("root");
const root = createRoot(container);
root.render(<Root />);

serviceWorker.unregister();
